import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'yz-no-data-inline',
  template: `
    <!--行内“暂无数据”效果-->
    <div class="yz-no-data-inline">
      <span class="yz-no-data-inline-tips" [ngStyle]="{'background':bg}">{{text || '暂无数据'}}</span>
    </div>`,
  styleUrls: ['./yz-no-data-inline.component.less']
})
export class YzNoDataInlineComponent implements OnInit {

  // 与当前页面背景应相同
  @Input() bg: string = '#ffffff';

  // 提示文字
  @Input() text: string = null;

  constructor() {
  }

  ngOnInit() {
  }

}
